module.exports = __webpack_public_path__ + "static/media/cameraWithAttachments.5af2669c.png";